import { render, staticRenderFns } from "./order-form.vue?vue&type=template&id=7e6a62da&"
import script from "./order-form.vue?vue&type=script&lang=ts&"
export * from "./order-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports